import React from 'react';


function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg bg-white sticky-top">
      {/* Brand/Logo on the left */}
      <a className="navbar-brand px-2" href="#">
        <img 
          src="/logo-option4.png" 
          alt="FTTBSA Logo" 
          style={{ height: '40px', width: '130px', objectFit: 'contain' }} 
        />
      </a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Nav links on the right */}
      <div className="collapse navbar-collapse justify-content-end text-end mx-2" id="navbarNav">
        <ul className="navbar-nav">
          <li className="nav-item active">
            <a className="nav-link" href="#Hero">Home </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#Packages">Fibre</a>
          </li>
          
          <li className="nav-item">
            <a className="nav-link" href="#Contact">Contact</a>
          </li>
        </ul>
        <button className="btn btn-outline-light ml-3" type="button" style={{backgroundColor:'#0f174f'}}>
          LOGIN
        </button>
      </div>
    </nav>
  );
}

export default Navbar;